// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2760":"12a60b58","3350":"a1a1f6d6","3764":"12a60b58","3857":"420031a6","4594":"12a60b58","7527":"12a60b58"}[chunkId] + ".chunk.css";
};